export const workExp = [{
    title: "Junior Software Engineer",
    employer: "Kanso Software | 2023-current",
    jobDescription:"Developed and Maintained Housing Management Software",
    jobDetails:[
      "Implemented government regulations into software functionality, achieving 100% compliance with industry standards.",
      "Proficiently designed and maintained Housing Management software solutions, ensuring seamless integration with AngularJS, Angular, Node.js, and .NET backend systems.",
      "Consistently exceeded project timelines, delivering new features 20% ahead of schedule",
      "Efficiently managed project deadlines, ensuring on-time completion of tasks and milestones, contributing to a 95% project completion rate."
    ]
  },
    {
      title: "Software Engineer Trainee/Interns",
      employer: "Per Scholas | 2022-2023",
      jobDescription:"",
      jobDetails:[
        "Provided clear explanations of complex coding concepts to peers, contributing to a noticeable 20% enhancement in classmates comprehension and proficiency in challenging topics.",
        "Conducted individual mentorship sessions, resulting in a significant 30% enhancement in participants' coding efficiency and problem-solving capabilities, showcasing impactful guidance and support.",
        "Actively sought feedback from mentors and peers, maintaining a high satisfaction rate of 90%, highlighting receptiveness to constructive criticism and a proactive approach to continuous learning.",
        "Efficiently managed project deadlines, ensuring on-time completion of tasks and milestones, contributing to a 95% project completion rate."
      ]  
    },
    {
      title: "Nail Technician",
      employer: "Snappy Nails LLC | 2021-2022",
      jobDescription:"",
      jobDetails:[
        "Demonstrated effective communication, utilizing language skills and customer service expertise, fostering positive interactions.",
        "Established and nurtured lasting customer relationships, enhancing overall customer satisfaction ratings by 20%.",
      ]  
    }
  ]